import { _, Backbone, Obscura } from "../../vendor";

import InboomaBaseAsyncCollection from "./InboomaBaseAsyncCollection";
import Calendar from "../models/Calendar";

export default InboomaBaseAsyncCollection.extend({
  collectionName: "calendars",
  model: Calendar,
  url: "/calendars",
});
